import {
  InputProps,
  ValidatedFieldProps,
  Widget,
} from '@kanda-libs/ks-component-ts';

import { AddressFieldType } from '../../..';

export interface AddressManualWidgets {
  BuildingName: (props: ValidatedFieldProps<InputProps>) => JSX.Element;
  BuildingNumber: (props: ValidatedFieldProps<InputProps>) => JSX.Element;
  Line1: (props: ValidatedFieldProps<InputProps>) => JSX.Element;
  Line2: (props: ValidatedFieldProps<InputProps>) => JSX.Element;
  City: (props: ValidatedFieldProps<InputProps>) => JSX.Element;
  County: (props: ValidatedFieldProps<InputProps>) => JSX.Element;
  Country: (props: ValidatedFieldProps<InputProps>) => JSX.Element;
}

const BASE_CURRENT_WIDGETS: AddressManualWidgets = {
  BuildingName: Widget.CreditCustomerDetailsCurrentAddressBuildingName,
  BuildingNumber: Widget.CreditCustomerDetailsCurrentAddressBuildingNumber,
  Line1: Widget.CreditCustomerDetailsCurrentAddressLine1,
  Line2: Widget.CreditCustomerDetailsCurrentAddressLine2,
  City: Widget.CreditCustomerDetailsCurrentAddressCity,
  County: Widget.CreditCustomerDetailsCurrentAddressCounty,
  Country: Widget.CreditCustomerDetailsCurrentAddressCountry,
};

const BASE_PREVIOUS_1_WIDGETS: AddressManualWidgets = {
  BuildingName: Widget.CreditCustomerDetailsPreviousAddressOneBuildingName,
  BuildingNumber: Widget.CreditCustomerDetailsPreviousAddressOneBuildingNumber,
  Line1: Widget.CreditCustomerDetailsPreviousAddressOneLine1,
  Line2: Widget.CreditCustomerDetailsPreviousAddressOneLine2,
  City: Widget.CreditCustomerDetailsPreviousAddressOneCity,
  County: Widget.CreditCustomerDetailsPreviousAddressOneCounty,
  Country: Widget.CreditCustomerDetailsPreviousAddressOneCountry,
};

const BASE_PREVIOUS_2_WIDGETS: AddressManualWidgets = {
  BuildingName: Widget.CreditCustomerDetailsPreviousAddressTwoBuildingName,
  BuildingNumber: Widget.CreditCustomerDetailsPreviousAddressTwoBuildingNumber,
  Line1: Widget.CreditCustomerDetailsPreviousAddressTwoLine1,
  Line2: Widget.CreditCustomerDetailsPreviousAddressTwoLine2,
  City: Widget.CreditCustomerDetailsPreviousAddressTwoCity,
  County: Widget.CreditCustomerDetailsPreviousAddressTwoCounty,
  Country: Widget.CreditCustomerDetailsPreviousAddressTwoCountry,
};

export const BASE_WIDGETS: Record<AddressFieldType, AddressManualWidgets> = {
  current: BASE_CURRENT_WIDGETS,
  previous1: BASE_PREVIOUS_1_WIDGETS,
  previous2: BASE_PREVIOUS_2_WIDGETS,
};
